import { render, staticRenderFns } from "./detailCard.vue?vue&type=template&id=1c1493dc&"
import script from "./detailCard.vue?vue&type=script&lang=js&"
export * from "./detailCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports